<template>
   <!-- Page wrapper  -->
        <!-- ============================================================== -->
        <div class="page-wrapper" v-if="12>211">
            <!-- ============================================================== -->
            <!-- Container fluid  -->
            <!-- ============================================================== -->
            <div class="container-fluid">
                <!-- ============================================================== -->
                <!-- Bread crumb and right sidebar toggle -->
                <!-- ============================================================== -->
                <div class="row page-titles">
                    <div class="col-md-5 align-self-center">
                        <h4 class="text-themecolor">Dashboard</h4>
                    </div>
                    <div class="col-md-7 align-self-center text-right">
                        <div class="d-flex justify-content-end align-items-center">
                            <ol class="breadcrumb">
                                <li class="breadcrumb-item"><a href="dashboard">Home</a></li>
                                <li class="breadcrumb-item active">Dashboard</li>
                            </ol>
                        </div>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-5">
                            <div class="card">
                                <div class="card-body">
                                    <div class="d-flex">
                                        <h4 class="card-title">Weather Report</h4>
                                        <select class="custom-select w-25 ml-auto">
                                            <option selected="">Today</option>
                                            <option value="1">Weekly</option>
                                        </select>
                                    </div>
                                    <div class="d-flex align-items-center flex-row m-t-30">
                                        <div class="p-2 display-5 text-info">
                                            <i class="wi wi-day-showers"></i>
                                            <span>73
                                                <sup>°</sup>
                                            </span>
                                        </div>
                                        <div class="p-2">
                                            <h3 class="m-b-0">Saturday</h3>
                                            <small>Ahmedabad, India</small>
                                        </div>
                                    </div>
                                    <table class="table no-border">
                                        <tbody>
                                            <tr>
                                                <td>Wind</td>
                                                <td class="font-medium">ESE 17 mph</td>
                                            </tr>
                                            <tr>
                                                <td>Humidity</td>
                                                <td class="font-medium">83%</td>
                                            </tr>
                                            <tr>
                                                <td>Pressure</td>
                                                <td class="font-medium">28.56 in</td>
                                            </tr>
                                            <tr>
                                                <td>Cloud Cover</td>
                                                <td class="font-medium">78%</td>
                                            </tr>
                                            <tr>
                                                <td>Ceiling</td>
                                                <td class="font-medium">25760 ft</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <hr>
                                    <ul class="list-unstyled row text-center city-weather-days">
                                        <li class="col">
                                            <i class="wi wi-day-sunny"></i>
                                            <span>09:30</span>
                                            <h3>70
                                                <sup>°</sup>
                                            </h3>
                                        </li>
                                        <li class="col">
                                            <i class="wi wi-day-cloudy"></i>
                                            <span>11:30</span>
                                            <h3>72
                                                <sup>°</sup>
                                            </h3>
                                        </li>
                                        <li class="col">
                                            <i class="wi wi-day-hail"></i>
                                            <span>13:30</span>
                                            <h3>75
                                                <sup>°</sup>
                                            </h3>
                                        </li>
                                        <li class="col">
                                            <i class="wi wi-day-sprinkle"></i>
                                            <span>15:30</span>
                                            <h3>76
                                                <sup>°</sup>
                                            </h3>
                                        </li>
                                    </ul>
                                </div>
                            </div>                            
                        </div>
                        <div class="col-7">
                            <div class="card">
                                <div class="card-body">
                                    <h4 class="card-title">Stage Preview</h4>
                                    <!--
                                    <div class="row">
                                        <div class="col-lg-2 col-md-6 m-b-30">
                                            <div class="chart easy-pie-chart-1" data-percent="75"><span class="percent"></span><div class="boldText">Stage 01</div></div>
                                        </div>
                                        <div class="col-lg-2 col-md-6 m-b-30">
                                            <div class="chart easy-pie-chart-1" data-percent="75"><span class="percent"></span><div class="boldText">Stage 02</div></div>
                                        </div>
                                        <div class="col-lg-2 col-md-6 m-b-30">
                                            <div class="chart easy-pie-chart-1" data-percent="45"><span class="percent"></span><div class="boldText">Stage 03</div></div>
                                        </div>
                                        <div class="col-lg-2 col-md-6 m-b-30">
                                            <div class="chart easy-pie-chart-1" data-percent="22"><span class="percent"></span><div class="boldText">Stage 04</div></div>
                                        </div>
                                        <div class="col-lg-2 col-md-6 m-b-30">
                                            <div class="chart easy-pie-chart-1" data-percent="35"><span class="percent"></span><div class="boldText">Stage 05</div></div>
                                        </div>
                                        <div class="col-lg-2 col-md-6 m-b-30">
                                            <div class="chart easy-pie-chart-1" data-percent="15"><span class="percent"></span><div class="boldText">Stage 06</div></div>
                                        </div>
                                    </div>
                                    -->
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <!-- Column -->
                        <div class="col-lg-2 col-md-6">
                            <div class="card">
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-12">
                                            <h3>86%</h3>
                                            <h6 class="card-subtitle boldText">Locations</h6></div>
                                        <div class="col-12">
                                            <div class="progress">
                                                <div class="progress-bar bg-success" role="progressbar" style="width: 85%; height: 6px;" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- Column -->

                        <!-- Column -->
                        <div class="col-lg-2 col-md-6">
                            <div class="card">
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-12">
                                            <h3>40%</h3>
                                            <h6 class="card-subtitle boldText">Patients</h6></div>
                                        <div class="col-12">
                                            <div class="progress">
                                                <div class="progress-bar bg-info" role="progressbar" style="width: 40%; height: 6px;" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- Column -->

                        <!-- Column -->
                        <div class="col-lg-2 col-md-6">
                            <div class="card">
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-12">
                                            <h3>56%</h3>
                                            <h6 class="card-subtitle boldText">Users</h6></div>
                                        <div class="col-12">
                                            <div class="progress">
                                                <div class="progress-bar bg-danger" role="progressbar" style="width: 56%; height: 6px;" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- Column -->

                        <!-- Column -->
                        <div class="col-lg-2 col-md-6">
                            <div class="card">
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-12">
                                            <h3>26%</h3>
                                            <h6 class="card-subtitle boldText">Texts</h6></div>
                                        <div class="col-12">
                                            <div class="progress">
                                                <div class="progress-bar bg-inverse" role="progressbar" style="width: 26%; height: 6px;" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- Column -->

                        <!-- Column -->
                        <div class="col-lg-2 col-md-6">
                            <div class="card">
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-12">
                                            <h3>26%</h3>
                                            <h6 class="card-subtitle boldText">Emails</h6></div>
                                        <div class="col-12">
                                            <div class="progress">
                                                <div class="progress-bar bg-inverse" role="progressbar" style="width: 26%; height: 6px;" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- Column -->

                        <!-- Column -->
                        <div class="col-lg-2 col-md-6">
                            <div class="card">
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-12">
                                            <h3>26%</h3>
                                            <h6 class="card-subtitle boldText">Payments</h6></div>
                                        <div class="col-12">
                                            <div class="progress">
                                                <div class="progress-bar bg-inverse" role="progressbar" style="width: 26%; height: 6px;" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- Column -->
                    </div>

                </div>
                <!-- ============================================================== -->

            </div>
            <!-- ============================================================== -->
            <!-- End Container fluid  -->
            <!-- ============================================================== -->
        </div>
        <!-- ============================================================== -->
        <!-- End Page wrapper  -->
        <!-- ============================================================== -->
            <!-- Patients Check in -->
    <div id="mergev2Modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" style="display: none;">
        <div class="modal-dialog cascading-modal modal-lg" role="document">
            <!-- Content -->
            <div class="modal-content">

              <!--Modal cascading tabs-->
              <div class="modal-c-tabs">
                  <!-- === Merge Patient Panel ==== -->
                    <!-- Body -->
                    <div class="modal-body mb-1 pt-2">
                      <div class="table-responsive">
                        <div class="container">
                            <div class="row mt-3 mb-3">
                                <button type="button" class="btn btn-outline-info waves-effect col-12" data-toggle="modal" data-target="#alertv3Modal">This is a New Patient</button>   
                            </div>                                
                        </div>

                        <hr class="solid text-black-50">
                        
                        <div class="row">
                            <div class="col-12">
                                <form class="floating-labels">
                                    <legend class="text-center" style="font-weight: 900;">Search in your Practice Patient Profile Database</legend>
                                    <div class="row">                                
                                        <div class="form-group m-b-40" style="margin-left: 10px;">
                                            <input type="text" class="form-control" id="" placeholder=""><span class="bar"></span>
                                            <label for="">Search By First Name</label>
                                        </div>
                                        <div class="form-group m-b-40" style="margin-left: 10px;">
                                            <input type="text" class="form-control" id="" placeholder=""><span class="bar"></span>
                                            <label for="">Search By Last Name</label>
                                        </div>
                                        <div class="form-group m-b-40" style="margin-left: 10px;">
                                            <input type="text" class="form-control" id="" placeholder=""><span class="bar"></span>
                                            <label for="">Search By Phone</label>
                                        </div>
                                        <div class="form-group m-b-40" style="margin-left: 10px;">
                                            <input type="date" class="form-control" id=""><span class="bar"></span>
                                        </div>
                                    </div>                                
                                </form>
                            </div>
                        </div>

                        <table  class="table display table-bordered table-striped no-wrap">
                            <thead class="thead-dark">
                                <tr>
                                    <th>PT ID</th>
                                    <th>SSN</th>
                                    <th>First Name</th>
                                    <th>Last Name</th>
                                    <th>DOB</th>
                                    <th>Email</th>
                                    <th>Phone</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>
                                        <button class="btn btn-facebook btn-sm waves-effect waves-light" type="button" data-toggle="modal" data-target="#alertv2Modal">1</button>
                                    </td>
                                    <td>1</td>
                                    <td>Shakir</td>
                                    <td>Ansari</td>
                                    <td>11/10/1999</td>
                                    <td>x@gmail.com</td>
                                    <td>9872712063</td>
                                </tr>
                                <tr>
                                    <td>
                                        <button class="btn btn-facebook btn-sm waves-effect waves-light" type="button" data-toggle="modal" data-target="#alertv2Modal">1</button>
                                    </td>
                                    <td>1</td>
                                    <td>Ravi</td>
                                    <td>A.</td>
                                    <td>11/10/1999</td>
                                    <td>x@gmail.com</td>
                                    <td>9872712063</td>
                                </tr>
                            </tbody>
                        </table>

                      </div>
                    </div>
                    
                    <!-- Footer -->
                    <div class="modal-footer">
                      <button type="button" class="btn btn-outline-info waves-effect ml-auto" data-dismiss="modal">Close</button>
                    </div>
                    <!-- Footer -->


                  <!-- === Merge Patient Panel ==== -->
              </div>
            </div>
            <!-- Content -->
          </div>
    </div>
    <!-- Patients Check in -->

    <!-- Alert V2-->
    <div class="modal bs-example-modal-lg fade" id="alertv2Modal" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true" style="display: none;">
        <div class="modal-dialog modal-xl">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">Est Patient Check In</h4>
                </div>
                <div class="row">
                    <div class="col-6">
                        <button type="button" class="btn btn-outline-success waves-effect waves-light col-12">Continue</button>
                    </div>
                    <div class="col-6">
                        <button type="button" class="btn btn-outline-danger waves-effect waves-light col-12" data-dismiss="modal">Close</button>  
                    </div>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-6">
                            <section id="step-1" class="section active m-b-40">
                                <div class="container text-center" id="middleFix">
                                    <h3 class="font-weight-bold h3Spacing text-center">Select Visit Type</h3>
                                        <!--Checkbox-->
                                        <div class="form-group">
                                        <div class="form-checkbox">
                                        <input required class="radio" type="radio" name="" id="" value="">
                                        <label class="checklabel modifiedRadio" for="">Walk In</label>  
                                        </div>
                    
                                        <div class="form-checkbox">
                                        <input required class="radio" type="radio" name="" id="" value="">
                                        <label class="checklabel modifiedRadio" for="">Appointment</label>  
                                        </div>
                    
                                        <div class="form-checkbox">
                                        <input required class="radio" type="radio" name="" id="" value="">
                                        <label class="checklabel modifiedRadio" for="">Telemedicine</label>  
                                        </div>
                    
                                        <div class="form-checkbox">
                                        <input required class="radio" type="radio" name="" id="" value="">
                                        <label class="checklabel modifiedRadio" for="">Phone Consult</label>  
                                        </div>
                    
                                        <div class="form-checkbox">
                                        <input required class="radio" type="radio" name="" id="" value="">
                                        <label class="checklabel modifiedRadio" for="">No visit</label>  
                                        </div>
                                        </div>
                                        <!--Checkbox-->
                                </div>

                            </section>
                        </div>

                        <div class="col-6">
                            <section id="step-2" class="section active m-b-40">
                                <div class="container text-center" id="middleFix">
                                        <h3 class="font-weight-bold h3Spacing text-center">Select Visit Reason</h3>
                                        <!--Checkbox-->
                                        <div class="form-group">
                                        <div class="form-checkbox">
                                        <input required class="radio" type="radio" name="" id="" value="">
                                        <label class="checklabel modifiedRadio" for="">Sick</label>  
                                        </div>
                    
                                        <div class="form-checkbox">
                                        <input required class="radio" type="radio" name="" id="" value="">
                                        <label class="checklabel modifiedRadio" for="">Physical</label>  
                                        </div>
                    
                                        <div class="form-checkbox">
                                        <input required class="radio" type="radio" name="" id="" value="">
                                        <label class="checklabel modifiedRadio" for="">Allergy test</label>  
                                        </div>
                    
                                        <div class="form-checkbox">
                                        <input required class="radio" type="radio" name="" id="" value="">
                                        <label class="checklabel modifiedRadio" for="">New Patient Sick</label>  
                                        </div>
                    
                                        <div class="form-checkbox">
                                        <input required class="radio" type="radio" name="" id="" value="">
                                        <label class="checklabel modifiedRadio" for="">New Patient Physical</label>  
                                        </div>
                    
                                        <div class="form-checkbox">
                                        <input required class="radio" type="radio" name="" id="" value="">
                                        <label class="checklabel modifiedRadio" for="">Med Rifil</label>  
                                        </div>
                    
                                        <div class="form-checkbox">
                                        <input required class="radio" type="radio" name="" id="" value="">
                                        <label class="checklabel modifiedRadio" for="">Follow Up</label>  
                                        </div>
                    
                                        <div class="form-checkbox">
                                        <input required class="radio" type="radio" name="" id="" value="">
                                        <label class="checklabel modifiedRadio" for="">Fluoride</label>  
                                        </div>
                    
                                        <div class="form-checkbox">
                                        <input required class="radio" type="radio" name="" id="" value="">
                                        <label class="checklabel modifiedRadio" for="">Circumcision</label>  
                                        </div>
                    
                                        <div class="form-checkbox">
                                        <input required class="radio" type="radio" name="" id="" value="">
                                        <label class="checklabel modifiedRadio" for="">Post E.R/ Urgent care</label>  
                                        </div>
                                        </div>
                                        <!--Checkbox-->
                                </div>
                            </section>                            
                        </div>

                        <div class="col-6">
                            <section id="step-3" class="section active m-b-40">
                            <div class="container form-containerV2">
                                <h3 class="font-weight-bold h3Spacing text-center">Basic Details</h3>
                                    <form class="floating-labels">
                                        <!-- first row -->
                                        <div class="row">
                                            <div class="col-lg-12">
                                            <!-- first name -->
                                            <div class="form-group focused m-b-40">
                                                <input type="text" class="form-control required" id="filler_name" name="filler_name">
                                                <label for="float-label">First Name</label>
                                            </div>
                                            <!-- first name -->
                                            </div>
                                            <div class="col-lg-12">
                                            <!-- last name -->
                                            <div class="form-group m-b-40">
                                                <input type="text" class="form-control required" id="" placeholder=""><span class="bar"></span>
                                                <label for="">Last Name</label>
                                            </div>
                                            <!-- last name -->
                                            </div>
                                        </div>
                                        <!-- first row -->
                    
                                        <!-- second row -->
                                        <div class="row">
                                            <div class="col-lg-12">
                                                <div class="form-group m-b-40">
                                                    <input type="date" class="form-control required" id="" placeholder=""><span class="bar"></span>
                                                </div>
                                            </div>
                    
                                            <div class="col-lg-12">
                                                <div class="form-group m-b-40">
                                                    <select class="form-control custom-select" tabindex="1">
                                                        <option value="">Choose a Gender</option>                                                            
                                                        <option value="">Male</option>
                                                        <option value="">Female</option>
                                                        <option value="">Others</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- second row -->
                    
                                        <!-- fourth row -->
                                        <div class="row">
                                                <div class="form-group m-b-40 col-12">
                                                    <input type="text" class="form-control required" id="" placeholder=""><span class="bar"></span>
                                                    <label for="">Social Security Number</label>
                                                </div>
                                        </div>
                                        <!-- fourth row -->
                                    </form>
                            </div>
                            </section>                            
                        </div>

                        <div class="col-6">
                            <section id="step-4" class="section active m-b-40">
                            <div class="container form-containerV2">                                
                                <h3 class="font-weight-bold h3Spacing text-center">Contact Information</h3>
                                <form class="floating-labels">
                                <!-- third row -->
                                <div class="row">
                                    <div class="col-lg-12">
                                        <div class="form-group m-b-40">
                                            <input type="tel" class="form-control required" id="" placeholder=""><span class="bar"></span>
                                            <label for="">Phone Number</label>
                                        </div>
                                    </div>
                                    <div class="col-lg-12">
                                        <div class="form-group m-b-40">
                                            <input type="email" class="form-control required" id="" placeholder=""><span class="bar"></span>
                                            <label for="">Email</label>
                                        </div>
                                    </div>
                                </div>
                                <!-- third row -->
                                </form>
                            </div>
                            </section> 
                            <section id="step-5" class="section active m-b-40">
                                <div class="container form-containerV2" style="margin-top: -165px !important;">
                                    <h3 class="font-weight-bold h3Spacing text-center">Address</h3>
                                    <form class="floating-labels">
                                        <!-- fifth row -->
                                        <div class="row">
                                        <div class="col-lg-12">
                                            <div class="form-group m-b-40">
                                                <input type="text" class="form-control required" id="" placeholder=""><span class="bar"></span>
                                                <label for="street">Street</label>
                                            </div>
                                        </div>
                                        <div class="col-lg-12">
                                            <div class="form-group m-b-40">
                                                <input type="text" class="form-control required" id="" placeholder=""><span class="bar"></span>
                                                <label for="city">City</label>
                                            </div>
                                        </div>
                        
                                        <div class="col-lg-12">
                                            <div class="form-group m-b-40">
                                                <input type="text" class="form-control required" id="" placeholder=""><span class="bar"></span>
                                                <label for="zip">Zip</label>
                                            </div>
                                        </div>
                        
                                        <div class="col-lg-12">
                                            <div class="form-group m-b-40">
                                                <select class="form-control custom-select" tabindex="1">
                                                    <option value="">Choose State</option>                                                            
                                                    <option value="FL">FL</option>
                                                    <option value="AL">AL</option>
                                                    <option value="AK">AK</option>
                                                    <option value="AZ">AZ</option>
                                                    <option value="AR">AR</option>
                                                    <option value="CA">CA</option>
                                                    <option value="CO">CO</option>
                                                    <option value="CT">CT</option>
                                                    <option value="DE">DE</option>
                                                    <option value="GA">GA</option>
                                                    <option value="HI">HI</option>
                                                    <option value="ID">ID</option>
                                                    <option value="IL">IL</option>
                                                    <option value="IN">IN</option>
                                                    <option value="IA">IA</option>
                                                    <option value="KS">KS</option>
                                                    <option value="KY">KY</option>
                                                    <option value="ME">ME</option>
                                                    <option value="MD">MD</option>
                                                    <option value="MA">MA</option>
                                                    <option value="MI">MI</option>
                                                    <option value="MN">MN</option>
                                                    <option value="MS">MS</option>
                                                    <option value="MO">MO</option>
                                                    <option value="MT">MT</option>
                                                    <option value="NE">NE</option>
                                                    <option value="NV">NV</option>
                                                    <option value="NH">NH</option>
                                                    <option value="NJ">NJ</option>
                                                    <option value="NM">NM</option>
                                                    <option value="NY">NY</option>
                                                    <option value="NC">NC</option>
                                                    <option value="ND">ND</option>
                                                    <option value="OH">OH</option>
                                                    <option value="OK">OK</option>
                                                    <option value="OR">OR</option>
                                                    <option value="PA">PA</option>
                                                    <option value="RI">RI</option>
                                                    <option value="SC">SC</option>
                                                    <option value="SD">SD</option>
                                                    <option value="TN">TN</option>
                                                    <option value="TX">TX</option>
                                                    <option value="UT">UT</option>
                                                    <option value="VT">VT</option>
                                                    <option value="VA">VA</option>
                                                    <option value="WA">WA</option>
                                                    <option value="WV">WV</option>
                                                    <option value="WI">WI</option>
                                                    <option value="WY">WY</option>
                                                </select>
                                            </div>
                                        </div>
                                        
                                        </div>
                                        <!-- fifth row -->
                                    </form>
                                </div>
                            </section>                             
                        </div> 

                        <div class="col-12">
                            <section id="step-6" class="section active m-b-40">
                                <div class="container form-containerV3">
                                    <h3 class="font-weight-bold h3Spacing text-center">Custom Demo</h3>
                                    <div class="row">

                                        <div class="col-6">
                                            <fieldset class="floating-labels">
                                                <div class="form-group focused m-b-40">
                                                    <input type="text" class="form-control required" id="filler_name" name="filler_name">
                                                    <label for="float-label">What Country are you from?</label>
                                                </div>
                                            </fieldset>
                                        </div>

                                        <div class="col-6" style="margin-top: -20px;">
                                            <fieldset class="floating-labels">
                                                <div class="form-group" style="margin-bottom: 2px !important;">
                                                    <p class="boldText">What are you symptoms (check the options below):</p>
                                                </div> 
                                            </fieldset>
                                            <div class="input-group">
                                                    <div class="row">
                                                        <div>
                                                            <input class="input1" type='checkbox' value='3' name='checkbox' id=''/>
                                                            <label for='checkbox1' class="btn btn-outline-info label2">Option O1</label>
                                                        </div>
                                                        <div>
                                                            <input class="input1" type='checkbox' value='4' name='checkbox' id=''/>
                                                            <label for='checkbox1' class="btn btn-outline-info label2">Option O2</label>
                                                        </div>
                                                    </div>
                                            </div>                                                
                                        </div>
                                        
                                        <div class="col-6" style="margin-top: -8px;">
                                                <label class="boldText m-b-20">Rate Your experience:</label>
                                            <div class="form-group"  style="margin-left: -40px;"> 
                                                <div class="input-group" style="width: 200% !important;">
                                                    <ul class="ul1">
                                                        <fieldset class="floating-labels">
                                                            <div class="row">
                                                                <div class="form-group col-1 m-r-40">
                                                                    <input class="input1" type='radio' value='1' name='radio' id='radio1'/>
                                                                    <label for='radio1' class="btn btn-outline-info label1" data-toggle="tooltip" data-placement="top" title="Very Bad">O1</label>
                                                                </div>
            
                                                                <div class="form-group col-1 m-r-40">
                                                                    <input class="input1" type='radio' value='2' name='radio' id='radio2'/>
                                                                    <label for='radio1' class="btn btn-outline-info label1" data-toggle="tooltip" data-placement="top" title="Bad">O2</label>
                                                                </div> 
                                                                
                                                                <div class="form-group col-1 m-r-40">
                                                                    <input class="input1" type='radio' value='3' name='radio' id='radio3'/>
                                                                    <label for='radio1' class="btn btn-outline-info label1" data-toggle="tooltip" data-placement="top" title="Modarate">O3</label>
                                                                </div> 
                                                                
                                                                <div class="form-group col-1 m-r-40">
                                                                    <input class="input1" type='radio' value='4' name='radio' id='radio4'/>
                                                                    <label for='radio1' class="btn btn-outline-info label1" data-toggle="tooltip" data-placement="top" title="Good">O4</label>
                                                                </div>   
                                                                
                                                                <div class="form-group col-1 m-r-40">
                                                                    <input class="input1" type='radio' value='5' name='radio' id='radio5'/>
                                                                    <label for='radio1' class="btn btn-outline-info label1" data-toggle="tooltip" data-placement="top" title="Very Good">O5</label>
                                                                </div>                                              
                                                            </div>
                                                        </fieldset>
                                                    </ul>
                                                </div>
                                            </div>

                                        </div>

                                        <div class="col-6">
                                            <fieldset class="floating-labels">
                                            <div class="form-group"  style="margin-bottom: 2px !important;">
                                                <p class="boldText">What are you symptoms (check the options below):</p>
                                            </div> 
                                            </fieldset>
                                            <div class="input-group">
                                                <div class="row">
                                                    <div>
                                                        <input class="input1" type='radio' value='1' name='radio' id='radio1'/>
                                                        <label for='radio1' class="btn btn-outline-info label1">Option O1</label>
                                                    </div>
                                                    <div>
                                                        <input class="input1" type='radio' value='2' name='radio' id='radio2'/>
                                                        <label for='radio2' class="btn btn-outline-info label1">Option O2</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        
                                        <div class="col-6">
                                            <fieldset class="floating-labels">
                                                <div class="form-group focused m-b-40">
                                                    <input type="text" class="form-control required" id="filler_name" name="filler_name">
                                                    <label for="float-label">Provide your Email Address:</label>
                                                </div>
                                            </fieldset>
                                        </div>

                                        <div class="col-6">
                                            <fieldset class="floating-labels">
                                                <div class="form-group focused m-b-40">
                                                    <input type="text" class="form-control required phone-inputmask" id="filler_name" name="filler_name">
                                                    <label for="float-label">Provide your phone number:</label>
                                                </div>
                                            </fieldset>
                                        </div>

                                        <div class="col-6" style="margin-top: -20px;">
                                            <fieldset class="floating-labels">
                                            <div class="form-group"  style="margin-bottom: 2px !important;">
                                                <p class="boldText">Put in your Date of Service:</p>
                                            </div>
                                            <div class="form-group" style="margin-top: -18px;">
                                                <input type="date" class="form-control" id=""><span class="bar"></span>
                                            </div>
                                            </fieldset>
                                        </div>
                                        
                                    </div>
                                
                                </div>
                            </section>                            
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Alert V2 -->

    <!-- Alert V3-->
    <div class="modal bs-example-modal-lg fade" id="alertv3Modal" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true" style="display: none;">
        <div class="modal-dialog modal-xl">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">New Patient Check In</h4>
                </div>
                <div class="row">
                    <div class="col-6">
                        <button type="button" class="btn btn-outline-success waves-effect waves-light col-12">Continue</button>
                    </div>
                    <div class="col-6">
                        <button type="button" class="btn btn-outline-danger waves-effect waves-light col-12" data-dismiss="modal">Close</button>  
                    </div>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-6">
                            <section id="step-1" class="section active m-b-40">
                                <div class="container text-center" id="middleFix">
                                    <h3 class="font-weight-bold h3Spacing text-center">Select Visit Type</h3>
                                        <!--Checkbox-->
                                        <div class="form-group">
                                        <div class="form-checkbox">
                                        <input required class="radio" type="radio" name="" id="" value="">
                                        <label class="checklabel modifiedRadio" for="">Walk In</label>  
                                        </div>
                    
                                        <div class="form-checkbox">
                                        <input required class="radio" type="radio" name="" id="" value="">
                                        <label class="checklabel modifiedRadio" for="">Appointment</label>  
                                        </div>
                    
                                        <div class="form-checkbox">
                                        <input required class="radio" type="radio" name="" id="" value="">
                                        <label class="checklabel modifiedRadio" for="">Telemedicine</label>  
                                        </div>
                    
                                        <div class="form-checkbox">
                                        <input required class="radio" type="radio" name="" id="" value="">
                                        <label class="checklabel modifiedRadio" for="">Phone Consult</label>  
                                        </div>
                    
                                        <div class="form-checkbox">
                                        <input required class="radio" type="radio" name="" id="" value="">
                                        <label class="checklabel modifiedRadio" for="">No visit</label>  
                                        </div>
                                        </div>
                                        <!--Checkbox-->
                                </div>

                            </section>
                        </div>

                        <div class="col-6">
                            <section id="step-2" class="section active m-b-40">
                                <div class="container text-center" id="middleFix">
                                        <h3 class="font-weight-bold h3Spacing text-center">Select Visit Reason</h3>
                                        <!--Checkbox-->
                                        <div class="form-group">
                                        <div class="form-checkbox">
                                        <input required class="radio" type="radio" name="" id="" value="">
                                        <label class="checklabel modifiedRadio" for="">Sick</label>  
                                        </div>
                    
                                        <div class="form-checkbox">
                                        <input required class="radio" type="radio" name="" id="" value="">
                                        <label class="checklabel modifiedRadio" for="">Physical</label>  
                                        </div>
                    
                                        <div class="form-checkbox">
                                        <input required class="radio" type="radio" name="" id="" value="">
                                        <label class="checklabel modifiedRadio" for="">Allergy test</label>  
                                        </div>
                    
                                        <div class="form-checkbox">
                                        <input required class="radio" type="radio" name="" id="" value="">
                                        <label class="checklabel modifiedRadio" for="">New Patient Sick</label>  
                                        </div>
                    
                                        <div class="form-checkbox">
                                        <input required class="radio" type="radio" name="" id="" value="">
                                        <label class="checklabel modifiedRadio" for="">New Patient Physical</label>  
                                        </div>
                    
                                        <div class="form-checkbox">
                                        <input required class="radio" type="radio" name="" id="" value="">
                                        <label class="checklabel modifiedRadio" for="">Med Rifil</label>  
                                        </div>
                    
                                        <div class="form-checkbox">
                                        <input required class="radio" type="radio" name="" id="" value="">
                                        <label class="checklabel modifiedRadio" for="">Follow Up</label>  
                                        </div>
                    
                                        <div class="form-checkbox">
                                        <input required class="radio" type="radio" name="" id="" value="">
                                        <label class="checklabel modifiedRadio" for="">Fluoride</label>  
                                        </div>
                    
                                        <div class="form-checkbox">
                                        <input required class="radio" type="radio" name="" id="" value="">
                                        <label class="checklabel modifiedRadio" for="">Circumcision</label>  
                                        </div>
                    
                                        <div class="form-checkbox">
                                        <input required class="radio" type="radio" name="" id="" value="">
                                        <label class="checklabel modifiedRadio" for="">Post E.R/ Urgent care</label>  
                                        </div>
                                        </div>
                                        <!--Checkbox-->
                                </div>
                            </section>                            
                        </div>

                        <div class="col-6">
                            <section id="step-3" class="section active m-b-40">
                            <div class="container form-containerV2">
                                <h3 class="font-weight-bold h3Spacing text-center">Basic Details</h3>
                                    <form class="floating-labels">
                                        <!-- first row -->
                                        <div class="row">
                                            <div class="col-lg-12">
                                            <!-- first name -->
                                            <div class="form-group focused m-b-40">
                                                <input type="text" class="form-control required" id="filler_name" name="filler_name">
                                                <label for="float-label">First Name</label>
                                            </div>
                                            <!-- first name -->
                                            </div>
                                            <div class="col-lg-12">
                                            <!-- last name -->
                                            <div class="form-group m-b-40">
                                                <input type="text" class="form-control required" id="" placeholder=""><span class="bar"></span>
                                                <label for="">Last Name</label>
                                            </div>
                                            <!-- last name -->
                                            </div>
                                        </div>
                                        <!-- first row -->
                    
                                        <!-- second row -->
                                        <div class="row">
                                            <div class="col-lg-12">
                                                <div class="form-group m-b-40">
                                                    <input type="date" class="form-control required" id="" placeholder=""><span class="bar"></span>
                                                </div>
                                            </div>
                    
                                            <div class="col-lg-12">
                                                <div class="form-group m-b-40">
                                                    <select class="form-control custom-select" tabindex="1">
                                                        <option value="">Choose a Gender</option>                                                            
                                                        <option value="">Male</option>
                                                        <option value="">Female</option>
                                                        <option value="">Others</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- second row -->
                    
                                        <!-- fourth row -->
                                        <div class="row">
                                                <div class="form-group m-b-40 col-12">
                                                    <input type="text" class="form-control required" id="" placeholder=""><span class="bar"></span>
                                                    <label for="">Social Security Number</label>
                                                </div>
                                        </div>
                                        <!-- fourth row -->
                                    </form>
                            </div>
                            </section>                            
                        </div>

                        <div class="col-6">
                            <section id="step-4" class="section active m-b-40">
                            <div class="container form-containerV2">                                
                                <h3 class="font-weight-bold h3Spacing text-center">Contact Information</h3>
                                <form class="floating-labels">
                                <!-- third row -->
                                <div class="row">
                                    <div class="col-lg-12">
                                        <div class="form-group m-b-40">
                                            <input type="tel" class="form-control required" id="" placeholder=""><span class="bar"></span>
                                            <label for="">Phone Number</label>
                                        </div>
                                    </div>
                                    <div class="col-lg-12">
                                        <div class="form-group m-b-40">
                                            <input type="email" class="form-control required" id="" placeholder=""><span class="bar"></span>
                                            <label for="">Email</label>
                                        </div>
                                    </div>
                                </div>
                                <!-- third row -->
                                </form>
                            </div>
                            </section> 
                            <section id="step-5" class="section active m-b-40">
                                <div class="container form-containerV2" style="margin-top: -165px !important;">
                                    <h3 class="font-weight-bold h3Spacing text-center">Address</h3>
                                    <form class="floating-labels">
                                        <!-- fifth row -->
                                        <div class="row">
                                        <div class="col-lg-12">
                                            <div class="form-group m-b-40">
                                                <input type="text" class="form-control required" id="" placeholder=""><span class="bar"></span>
                                                <label for="street">Street</label>
                                            </div>
                                        </div>
                                        <div class="col-lg-12">
                                            <div class="form-group m-b-40">
                                                <input type="text" class="form-control required" id="" placeholder=""><span class="bar"></span>
                                                <label for="city">City</label>
                                            </div>
                                        </div>
                        
                                        <div class="col-lg-12">
                                            <div class="form-group m-b-40">
                                                <input type="text" class="form-control required" id="" placeholder=""><span class="bar"></span>
                                                <label for="zip">Zip</label>
                                            </div>
                                        </div>
                        
                                        <div class="col-lg-12">
                                            <div class="form-group m-b-40">
                                                <select class="form-control custom-select" tabindex="1">
                                                    <option value="">Choose State</option>                                                            
                                                    <option value="FL">FL</option>
                                                    <option value="AL">AL</option>
                                                    <option value="AK">AK</option>
                                                    <option value="AZ">AZ</option>
                                                    <option value="AR">AR</option>
                                                    <option value="CA">CA</option>
                                                    <option value="CO">CO</option>
                                                    <option value="CT">CT</option>
                                                    <option value="DE">DE</option>
                                                    <option value="GA">GA</option>
                                                    <option value="HI">HI</option>
                                                    <option value="ID">ID</option>
                                                    <option value="IL">IL</option>
                                                    <option value="IN">IN</option>
                                                    <option value="IA">IA</option>
                                                    <option value="KS">KS</option>
                                                    <option value="KY">KY</option>
                                                    <option value="ME">ME</option>
                                                    <option value="MD">MD</option>
                                                    <option value="MA">MA</option>
                                                    <option value="MI">MI</option>
                                                    <option value="MN">MN</option>
                                                    <option value="MS">MS</option>
                                                    <option value="MO">MO</option>
                                                    <option value="MT">MT</option>
                                                    <option value="NE">NE</option>
                                                    <option value="NV">NV</option>
                                                    <option value="NH">NH</option>
                                                    <option value="NJ">NJ</option>
                                                    <option value="NM">NM</option>
                                                    <option value="NY">NY</option>
                                                    <option value="NC">NC</option>
                                                    <option value="ND">ND</option>
                                                    <option value="OH">OH</option>
                                                    <option value="OK">OK</option>
                                                    <option value="OR">OR</option>
                                                    <option value="PA">PA</option>
                                                    <option value="RI">RI</option>
                                                    <option value="SC">SC</option>
                                                    <option value="SD">SD</option>
                                                    <option value="TN">TN</option>
                                                    <option value="TX">TX</option>
                                                    <option value="UT">UT</option>
                                                    <option value="VT">VT</option>
                                                    <option value="VA">VA</option>
                                                    <option value="WA">WA</option>
                                                    <option value="WV">WV</option>
                                                    <option value="WI">WI</option>
                                                    <option value="WY">WY</option>
                                                </select>
                                            </div>
                                        </div>
                                        
                                        </div>
                                        <!-- fifth row -->
                                    </form>
                                </div>
                            </section>                             
                        </div> 

                        <div class="col-12">
                            <section id="step-6" class="section active m-b-40">
                                <div class="container form-containerV3">
                                    <h3 class="font-weight-bold h3Spacing text-center">Custom Demo</h3>
                                    <div class="row">

                                        <div class="col-6">
                                            <fieldset class="floating-labels">
                                                <div class="form-group focused m-b-40">
                                                    <input type="text" class="form-control required" id="filler_name" name="filler_name">
                                                    <label for="float-label">What Country are you from?</label>
                                                </div>
                                            </fieldset>
                                        </div>

                                        <div class="col-6" style="margin-top: -20px;">
                                            <fieldset class="floating-labels">
                                                <div class="form-group" style="margin-bottom: 2px !important;">
                                                    <p class="boldText">What are you symptoms (check the options below):</p>
                                                </div> 
                                            </fieldset>
                                            <div class="input-group">
                                                    <div class="row">
                                                        <div>
                                                            <input class="input1" type='checkbox' value='3' name='checkbox' id=''/>
                                                            <label for='checkbox1' class="btn btn-outline-info label2">Option O1</label>
                                                        </div>
                                                        <div>
                                                            <input class="input1" type='checkbox' value='4' name='checkbox' id=''/>
                                                            <label for='checkbox1' class="btn btn-outline-info label2">Option O2</label>
                                                        </div>
                                                    </div>
                                            </div>                                                
                                        </div>
                                        
                                        <div class="col-6" style="margin-top: -8px;">
                                                <label class="boldText m-b-20">Rate Your experience:</label>
                                            <div class="form-group"  style="margin-left: -40px;"> 
                                                <div class="input-group" style="width: 200% !important;">
                                                    <ul class="ul1">
                                                        <fieldset class="floating-labels">
                                                            <div class="row">
                                                                <div class="form-group col-1 m-r-40">
                                                                    <input class="input1" type='radio' value='1' name='radio' id='radio1'/>
                                                                    <label for='radio1' class="btn btn-outline-info label1" data-toggle="tooltip" data-placement="top" title="Very Bad">O1</label>
                                                                </div>
            
                                                                <div class="form-group col-1 m-r-40">
                                                                    <input class="input1" type='radio' value='2' name='radio' id='radio2'/>
                                                                    <label for='radio1' class="btn btn-outline-info label1" data-toggle="tooltip" data-placement="top" title="Bad">O2</label>
                                                                </div> 
                                                                
                                                                <div class="form-group col-1 m-r-40">
                                                                    <input class="input1" type='radio' value='3' name='radio' id='radio3'/>
                                                                    <label for='radio1' class="btn btn-outline-info label1" data-toggle="tooltip" data-placement="top" title="Modarate">O3</label>
                                                                </div> 
                                                                
                                                                <div class="form-group col-1 m-r-40">
                                                                    <input class="input1" type='radio' value='4' name='radio' id='radio4'/>
                                                                    <label for='radio1' class="btn btn-outline-info label1" data-toggle="tooltip" data-placement="top" title="Good">O4</label>
                                                                </div>   
                                                                
                                                                <div class="form-group col-1 m-r-40">
                                                                    <input class="input1" type='radio' value='5' name='radio' id='radio5'/>
                                                                    <label for='radio1' class="btn btn-outline-info label1" data-toggle="tooltip" data-placement="top" title="Very Good">O5</label>
                                                                </div>                                              
                                                            </div>
                                                        </fieldset>
                                                    </ul>
                                                </div>
                                            </div>

                                        </div>

                                        <div class="col-6">
                                            <fieldset class="floating-labels">
                                            <div class="form-group"  style="margin-bottom: 2px !important;">
                                                <p class="boldText">What are you symptoms (check the options below):</p>
                                            </div> 
                                            </fieldset>
                                            <div class="input-group">
                                                <div class="row">
                                                    <div>
                                                        <input class="input1" type='radio' value='1' name='radio' id='radio1'/>
                                                        <label for='radio1' class="btn btn-outline-info label1">Option O1</label>
                                                    </div>
                                                    <div>
                                                        <input class="input1" type='radio' value='2' name='radio' id='radio2'/>
                                                        <label for='radio2' class="btn btn-outline-info label1">Option O2</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        
                                        <div class="col-6">
                                            <fieldset class="floating-labels">
                                                <div class="form-group focused m-b-40">
                                                    <input type="text" class="form-control required" id="filler_name" name="filler_name">
                                                    <label for="float-label">Provide your Email Address:</label>
                                                </div>
                                            </fieldset>
                                        </div>

                                        <div class="col-6">
                                            <fieldset class="floating-labels">
                                                <div class="form-group focused m-b-40">
                                                    <input type="text" class="form-control required phone-inputmask" id="filler_name" name="filler_name">
                                                    <label for="float-label">Provide your phone number:</label>
                                                </div>
                                            </fieldset>
                                        </div>

                                        <div class="col-6" style="margin-top: -20px;">
                                            <fieldset class="floating-labels">
                                            <div class="form-group"  style="margin-bottom: 2px !important;">
                                                <p class="boldText">Put in your Date of Service:</p>
                                            </div>
                                            <div class="form-group" style="margin-top: -18px;">
                                                <input type="date" class="form-control" id=""><span class="bar"></span>
                                            </div>
                                            </fieldset>
                                        </div>
                                        
                                    </div>
                                
                                </div>
                            </section>                            
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Alert V3 -->
</template>

<script>
export default {
    data() {
    return {
      //Timer
      TimerObject: {},
      count: 1
    };
  },
methods: {
  StartLogoutTime() {
      this.TimerObject = setTimeout(() => {
        this.AutoLogout();
      }, this.LogoutTime);
    },
},
  beforeCreate() {
    // //debugger// eslint-disable-line no-debugger
    //   const paras = this.$route.query.index;
    //   console.log(paras);
    // if(localStorage.OSversion == paras) { return; }
    // if(typeof paras!=='undefined' && paras.length > 1) {
    //   localStorage.OSversion=this.$route.query.index;
    //   localStorage.xeon=this.$route.query.area;
    //   if(this.$route.query.display !== undefined)
    //   {
    //       this.$router.push({ path: '/StageDisplay'});
    //   }
    //   return;
    // }
    //location.reload();
  },
  created(){
      const paras = this.$route.query.index;
      const paras1 = this.$route.query.area;
      this.$store.dispatch("setNewlocalStorage", paras);
      this.$store.dispatch("setNewlocalStorageXeon", paras1);
      console.log(paras);
    if(localStorage.OSversion == paras) { return; }
    if(localStorage.xeon == paras1) {return; }
    if(typeof paras!=='undefined' && paras.length > 1) {
      localStorage.OSversion=this.$route.query.index;
      localStorage.xeon=this.$route.query.area;
    //   if(this.$route.query.display !== undefined)
    //   {
        //   this.$router.push({ path: '/StageDisplay'});
    //   }
      return;
    }
  },
  mounted() {
      this.StartLogoutTime();
     //debugger
      var item = this.$store.getters.getLocalStoragecando;
      if(localStorage.cando !==undefined)
      {
      //  this.$router.push({ path: '/StageDisplay'});
      }
      //this.StartLogoutTime();
  },
  unmounted() {
        clearTimeout(this.TimerObject);
      },
};
</script>
